import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/form'
import { Switch } from '@/components/ui/switch'
import type { CreateAppFormValues } from '@/routes/apps/create-app/form/schema'

export const AutoDeploy = () => {
  const form = useFormContext<CreateAppFormValues>()
  const { resetField } = form
  const source = form.watch('source')

  useEffect(() => {
    return () => {
      resetField('autodeploy')
    }
  }, [resetField])

  if (source !== 'privateGit') {
    return null
  }

  return (
    <FormField
      control={form.control}
      name="autodeploy"
      render={({ field }) => (
        <FormItem>
          <div className="flex items-center justify-between border rounded-lg shadow-xs p-4 gap-16">
            <div className="space-y-1">
              <FormLabel>Auto-deploy</FormLabel>
              <FormDescription>
                Trigger deployment on every GIT push to the selected default
                branch
              </FormDescription>
            </div>
            <FormControl>
              <Switch
                checked={Boolean(field.value)}
                onCheckedChange={field.onChange}
              />
            </FormControl>
          </div>
        </FormItem>
      )}
    />
  )
}
